export default __webpack_public_path__ + "static/media/330_dummy2016-architekturbuero01-monbile-de.3fa7f846.png";